import config from "config";

export const api_url = config.HTTP_SERVER;
